import React, { Component } from "react";
import { Modal, Button, textarea } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from '../actions/index';
import moment from 'moment';
import * as constants from '../const';

class PayperiodModal extends React.Component {
  constructor(props) {
    super(props);
  }

  hideModal(){
    this.props.hideModal(false, constants.hosModals.payperiod_modal);
  }
  // render notes component
  renderNotesModal() {
    if (this.props.showModal) {
      return (
        <Modal className="notesModalContainer"
          show={
            this.props.showModal && this.props.modalName == constants.hosModals.payperiod_modal
          }
          onHide={() => this.hideModal.bind(this)}
        >
          <Modal.Header>
            <button type="button" className="close" onClick={() => this.hideModal()}>
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button>
            <div className="hos-modal-header">
              
            </div>
          </Modal.Header>
          
          <Modal.Body className="notesModalBody">

          </Modal.Body>
        </Modal>
      );
    } else {
      <div />;
    }
  }

  render() {
    return this.renderNotesModal();
  }
}

function mapStateToProps(state) {
  // coming from store
  return {
    showModal: state.modals.showModal,
    modalName: state.modals.modalName
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
        hideModal: actions.hideModalAction
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(PayperiodModal);